import { createFileRoute } from '@tanstack/react-router';
import { CircularsInboxPage } from '@/features/circulars/CircularsInboxPage';

/* Le circolari ricevute (task 2055), senza le note di rilascio, che stanno su `/circulars/release-notes`.
   `?open=` la apre subito: ci porta il campanello. */
export const Route = createFileRoute('/_app/circulars/')({
  component: CircularsInboxRoute,
  validateSearch: (s: Record<string, unknown>): { open?: string } =>
    (typeof s.open === 'string' && s.open ? { open: s.open } : {}),
});

function CircularsInboxRoute() {
  return <CircularsInboxPage kind="circulars" openId={Route.useSearch().open ?? null} />;
}
